var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62224 10.7149L12.9065 7.30428L13.0119 7.22079C13.4449 6.87794 13.518 6.249 13.1751 5.81602C13.1276 5.75607 13.0735 5.70176 13.0136 5.65416L8.62229 2.16168C8.25791 1.87189 7.74175 1.87189 7.37738 2.16168L2.98305 5.65656C2.5508 6.00033 2.47908 6.62942 2.82285 7.06167C2.86983 7.12074 2.92335 7.1743 2.98238 7.22133L3.0865 7.30428L7.3771 10.7153C7.74162 11.0051 8.25791 11.005 8.62224 10.7149Z",
    fill: "#323130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37123 12.4472L3.55762 9.4153C3.29736 9.20839 2.91864 9.25164 2.71173 9.51191C2.71014 9.51391 2.70856 9.51592 2.707 9.51794C2.50205 9.78259 2.55044 10.1633 2.8151 10.3682C2.81606 10.369 2.81702 10.3697 2.81798 10.3705L7.39185 13.8688C7.75038 14.143 8.24817 14.1431 8.60675 13.8689L13.1789 10.3732C13.4465 10.1686 13.4976 9.78565 13.293 9.51796C13.2921 9.51681 13.2912 9.51567 13.2903 9.51453C13.0848 9.24961 12.7034 9.20147 12.4385 9.40701C12.4366 9.4085 12.4346 9.41001 12.4327 9.41152L8.616 12.447C8.25168 12.7368 7.73561 12.7368 7.37123 12.4472Z",
    fill: "#323130"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.29c5d34b.svg";
export { ForwardRef as ReactComponent };